export default "__VITE_ASSET__CSpr_jVN__"